import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BusinessUnit, CreateBusinessDomainRequest } from './bd-creation/models/business-domain.model-creation';
import { BusinessDomain } from '../common/models/business-domain.model';

@Injectable({
    providedIn: 'root',
})
export class BusinessDomainService {
    public constructor(private readonly httpClient: HttpClient) {}

    public listBusinessDomains(params: { returnAll: boolean }): Observable<BusinessDomain[]> {
        return this.httpClient.get<BusinessDomain[]>(`business-domains?returnAll=${params.returnAll}`);
    }

    public getBusinessDomainOptions(): Observable<BusinessUnit> {
        return this.httpClient.get<BusinessUnit>('business-domains-options');
    }

    public createBusinessDomain(businessDomain: CreateBusinessDomainRequest): Observable<BusinessDomain> {
        return this.httpClient.post<BusinessDomain>('business-domains', businessDomain);
    }

    public getBusinessDomainDetails(businessDomainId: string): Observable<BusinessDomain> {
        return this.httpClient.get<BusinessDomain>(`business-domains/${businessDomainId}`);
    }
}
